import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=00f6895c&scoped=true&"
import script from "./Uploader.vue?vue&type=script&lang=js&"
export * from "./Uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.scss?vue&type=style&index=0&id=00f6895c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6895c",
  null
  
)

export default component.exports